import { useEffect, useRef, useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { quickRecord, triageInbox } from "../../api/hub/ai";
export function QuickTaskInput({ autoFocus = false }: { autoFocus?: boolean }) {
  const [text, setText] = useState(""),
    [message, setMessage] = useState("");
  const ref = useRef<HTMLInputElement>(null),
    recordedId = useRef<string | null>(null),
    qc = useQueryClient();
  useEffect(() => {
    if (autoFocus) ref.current?.focus();
  }, [autoFocus]);
  const submit = useMutation({
    mutationFn: async () => {
      if (!recordedId.current) {
        const item = await quickRecord({
          title: text.trim(),
          content: text.trim(),
          sourceUrl: "",
        });
        recordedId.current = item.id;
      }
      await triageInbox(recordedId.current);
    },
    onSuccess: () => {
      recordedId.current = null;
      setText("");
      setMessage("已整理，等你在「等我拍板」确认。");
      void qc.invalidateQueries({ queryKey: ["hub"] });
    },
  });
  return (
    <form
      className="work-quick"
      onSubmit={(e) => {
        e.preventDefault();
        if (text.trim()) {
          setMessage("");
          submit.mutate();
        }
      }}
    >
      <input
        ref={ref}
        aria-label="一句话记任务"
        placeholder="说一句要做什么…"
        value={text}
        disabled={submit.isPending || !!recordedId.current}
        onChange={(e) => setText(e.target.value)}
      />
      <button disabled={!text.trim() || submit.isPending}>
        {submit.isPending ? "整理中…" : "整理待确认"}
      </button>
      {message && <p role="status">{message}</p>}
      {submit.isError && (
        <p role="alert">
          {submit.error.message}
          {recordedId.current && "。原记录已保留，重新点击只重试整理。"}
        </p>
      )}
    </form>
  );
}
